@if (showDesktopModal()) {
  <app-desktop-ad-modal
    [rewardAmount]="watchAdReward"
    (rewarded)="onDesktopRewarded()"
    (dismissed)="onDesktopDismissed()"
    (failedToLoad)="onDesktopFailedToLoad()"
  ></app-desktop-ad-modal>
}

<div class="tw-flex tw-flex-col tw-gap-3 tw-relative">
  @for (vm of adViewModels(); track vm.id; let i = $index) {
    <button
      #AdItemEl
      type="button"
      (click)="showAdModal(i)"
      [disabled]="vm.isDisabled"
      class="tw-w-full tw-h-16 tw-flex tw-items-center tw-gap-[15px] tw-pl-[15px] tw-pr-[15px] tw-rounded-lg tw-overflow-hidden tw-text-left tw-transition-all tw-duration-150"
      [ngClass]="vm.containerClass"
      [style.background-color]="vm.containerBg"
    >
      <div
        class="tw-relative tw-w-10 tw-h-10 tw-bg-color-surface-elevated tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg"
      >
        @if (vm.isLoading) {
          <div class="loading-fill tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-[20]"></div>
        }

        <div
          class="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-z-10 tw-gap-0.5"
          [ngClass]="vm.iconBgClass"
        >
          <icon
            [name]="vm.iconName"
            [size]="vm.iconSize"
            [class]="vm.iconClass"
            [disableArrowOverride]="true"
          ></icon>
          @if (vm.showTimer) {
            <div
              class="tw-bg-color-surface-card tw-rounded-md tw-px-1 tw-py-0 tw-leading-none tw-item-center"
            >
              <span class="tw-text-color-text-default tw-text-[8px] tw-font-bold tw-tabular-nums">
                {{ formatTimeRemaining(vm.timeRemaining) }}
              </span>
            </div>
          }
        </div>
      </div>

      <div class="tw-flex-1 tw-flex tw-items-center tw-gap-2">
        <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-1">
          <span
            class="tw-font-Montserrat tw-font-semibold tw-text-[14px] tw-leading-[1.25]"
            [ngClass]="vm.titleClass"
          >
            {{ vm.title }}
          </span>
          <span
            class="tw-text-[12px] tw-leading-[1.25] tw-max-w-[200px]"
            [ngClass]="vm.descriptionClass"
          >
            {{ vm.description }}
          </span>
        </div>
        <span class="tw-font-medium tw-text-[15px] tw-leading-[125%]">
          <span [ngClass]="vm.pointsClass">{{ vm.points.slice(0, -3) }}</span>
          <span class="tw-text-[12px] tw-text-color-text-tertiary">{{ vm.points.slice(-3) }}</span>
        </span>
      </div>
    </button>

    @if (highlightedAdIndex() === i && isFromGuide()) {
      <div class="tw-w-full tw-z-[100] tw-relative">
        <app-task-info-tooltips
          class="tw-w-full"
          [tooltipLayout]="'inline'"
          [taskTitle]="'watchAdsToEarn'"
          [taskDescription]="
            tryAgainLaterInTutorial() ? 'tryAgainLaterInTutorial' : 'watchAdsToEarnDesc'
          "
          [guideTitle]="guideTitle()"
          [bottomAction]="tryAgainLaterInTutorial() || isWatchAdTaskSucceeded() ? 'back' : 'none'"
        ></app-task-info-tooltips>
      </div>
    }
  }

  @if (devMode) {
    <button
      type="button"
      (click)="openTestAd()"
      class="tw-w-full tw-text-center tw-text-[11px] tw-text-color-text-disabled tw-border tw-border-dashed tw-border-color-border-strong tw-rounded-xl tw-py-2 hover:tw-border-color-border-action hover:tw-text-color-text-action tw-transition-colors"
    >
      [DEV] Test Desktop Ad Modal
    </button>
  }

  <!--             Data Bundles Section  -->
  @if (DataBundleSectionReady) {
    <div
      class="tw-p-3 tw-bg-color-surface-elevated tw-border tw-border-color-border-subtle tw-rounded-xl"
    >
      <div class="tw-flex tw-items-start tw-gap-3">
        <div class="tw-p-[6px] tw-bg-color-accent-today-bg tw-rounded-[10px]">
          <icon [size]="6" [name]="'coins-hand'"></icon>
        </div>
        <div class="tw-flex tw-flex-col tw-gap-1">
          <span
            class="tw-font-medium tw-text-[13px] tw-tracking-[0.01em] tw-text-color-text-default"
            >Create a data bundle</span
          >
          <span class="tw-text-color-text-tertiary"
            >Securely share anonymized transaction data to earn credits</span
          >
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-w-full tw-items-end tw-mt-3 tw-gap-2">
        <app-gloss-button
          [options]="{
            text: 'viewBundleHistory' | i18n,
            isEnabled: true,
            onClick: onViewBundleHistory.bind(this),
            class: 'neutral',
          }"
        ></app-gloss-button>
        <app-gloss-button
          [options]="{
            text: 'createDataBundle' | i18n,
            isEnabled: true,
            onClick: onCreateBundle.bind(this),
            class: 'primary',
          }"
        ></app-gloss-button>
      </div>
    </div>
  }
</div>

<style>
  .loading-fill {
    height: 0;
    animation:
      fillUp 3s ease-in-out infinite,
      colorChange 3s ease-in-out infinite;
  }

  @keyframes fillUp {
    0% {
      height: 0%;
    }
    100% {
      height: 100%;
    }
  }

  @keyframes colorChange {
    0% {
      background-color: rgba(0, 194, 168, 0.3);
    }
    25% {
      background-color: rgba(59, 130, 246, 0.3);
    }
    50% {
      background-color: rgba(168, 85, 247, 0.3);
    }
    75% {
      background-color: rgba(236, 72, 153, 0.3);
    }
    100% {
      background-color: rgba(0, 194, 168, 0.3);
    }
  }
</style>
